<template>
  <div class="teachingTrack">
    <div class="title clearfix">
      <span
        class="fl"
        style="border-left: 4px solid #409eff; padding-left: 20px"
        >教学轨迹</span
      >
      <!-- <span class="fr">更多 ></span> -->
    </div>
    <div v-if="list.length">
      <div class="box clearfix" v-for="(item, index) in list" :key="index">
        <div class="fl">
          <img
            src="../../assets/course.jpg"
            alt=""
            style="width: 155px; height: 105px"
          />
        </div>
        <div class="info clearfix">
          <div class="fl">
            <p>
              <span class="color">班级：</span>
              <span style="color: #fe4343"
                >{{ item.grade_name + item.class_name == ''?'未知班级':item.grade_name + item.class_name }}</span
              >
            </p>
            <p>
              <span class="color">科目：{{ item.subject_name }}</span>
            </p>
            <!-- <p><span class="color">学生数量：</span>62 人</p> -->
          </div>
          <div class="fr">
            <p style="margin-left: 80px">
              <span class="color">开始时间：</span>{{ item.start_time }}
            </p>
            <p style="margin-left: 80px">
              <span class="color">课堂时长：</span>{{Math.ceil((new Date(item.end_time).getTime()-new Date(item.start_time).getTime())/1000/60)}} 分钟
            </p>
          </div>

          <!-- <p style="color: #65c9f9">点击查看详情 >></p> -->
        </div>
      </div>
      <div style="text-align: center">
        <el-pagination
          layout="prev, pager, next"
          :total="count"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else>
      <div style="text-align: center; padding: 20px 0">暂无数据..</div>
    </div>
  </div>
</template>

<script>
import eventBus from "../../api/eventBus";
import URL from "@/api/index";
export default {
  data() {
    return {
      list: [],
      class_id: "",
      subject: "",
      loginInfo: {},  
      grade_name: null,
      page: 1,
      currentPage: 1,
      count:''
    };
  },
  components: {},
  mounted() {
    this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.handleLog(this.page);
  },
  methods: {
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      this.handleLog(this.page);
    },
    handleLog(e) {
      this.$post("http://47.114.82.146:30002/remarkPc/pcClassListUserFind?user_id="+this.loginInfo.user_id+"&pageNum="+e+"&pageSize=5").then((res) => {
        // console.log(res.data.list);
        this.list = res.data.list
        this.count = res.data.total
      });
    },

  },
};
</script>

<style lang='less'>
.teachingTrack {
  width: 790px;
  margin-top: 15px;
  border-radius: 8px;
  padding: 10px 20px;
  background-color: #fff;
  margin-bottom: 40px;

  .title {
    padding-bottom: 10px;
    margin-bottom: 26px;
    font-size: 18px;
    border-bottom: 1px solid #f4f4f4;
    span {
      font-size: 16px;
    }
  }
  .box {
    border-radius: 8px;
    margin-bottom: 20px;
    padding: 15px 15px;
    // border: 1px solid #59abff;
    // .subject {
    //   background-color: #59abff;
    //   padding: 36px;
    //   color: #fff;
    //   font-size: 24px;
    //   border-radius: 4px;
    background-color: rgb(250, 248, 248);
    //
    .info {
      margin-left: 180px;
      padding-top: 15px;
      .color {
        color: #8d8a8a;
      }
      div {
        display: inline-block;
        margin-right: 50px;
        p {
          margin-bottom: 25px;
        }
      }
    }
  }
}
</style>
